import React from 'react';
import Box from '-/style/base/Box';
import Subhead from '-/style/base/Subhead';
import { GET_COMPANY_MONDAY_TURNDOWNS } from '-/gql/company';
import { graphql } from 'react-apollo';
import { get } from 'lodash';
import StandardTable from './StandardTable';
import LoadingLogo from '-/components/LoadingLogo';
import { TurndownRow } from './StandardRow';
import { TurndownHeader } from './StandardHeader';
import { StyledEmptyRow } from '-/style/base/Table';
const EmptyRow = <StyledEmptyRow colSpan={8}>No companies.</StyledEmptyRow>;
const Turndowns = props => {
    const { data = {} } = props;
    const { loading } = data;
    const companies = get(data, 'CompanyMondayReport.turndowns', []);
    if (loading) {
        return <LoadingLogo />;
    }
    return (
        <Box>
            <Subhead>Turndowns</Subhead>
            <StandardTable
                data={companies}
                Row={TurndownRow}
                Header={TurndownHeader}
                EmptyRow={EmptyRow}
            />
        </Box>
    );
};

export default graphql(GET_COMPANY_MONDAY_TURNDOWNS)(Turndowns);
